import { Gauge, AlertTriangle, Ban } from "lucide-react";

const COLORS = { ok: "#5CB85C", attention: "#D4AF5A", alerte: "#E0702E", bloque: "#D9534F" };
const LABELS = { ok: "Conforme", attention: "Approche du seuil", alerte: "Alerte : seuil 20 % proche", bloque: "Seuil dépassé — télésoin bloqué" };

/** Jauge activité à distance / activité totale (seuil 20 %, 12 mois glissants). */
export function ActivityGauge({ c, compact }) {
  if (!c) return null;
  const pct = Math.min(100, c.ratio_pct);
  const color = COLORS[c.niveau];
  return (
    <div data-testid="activity-gauge" className={`rounded-3xl border p-4 ${c.niveau === "ok" ? "bg-white border-[#E4E0D5]" : "border-2"}`} style={c.niveau !== "ok" ? { borderColor: color, background: `${color}10` } : undefined}>
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-2 text-[#0A1426]"><Gauge size={18} style={{ color }} /><span className="text-[11px] uppercase tracking-wider font-bold text-[#0A1426]/60">Compteur 20 % · télésoin</span></div>
        <span data-testid="activity-gauge-level" className="text-[11px] font-bold px-2.5 py-1 rounded-full text-white inline-flex items-center gap-1" style={{ background: color }}>
          {c.niveau === "bloque" ? <Ban size={12} /> : c.niveau !== "ok" ? <AlertTriangle size={12} /> : null}{LABELS[c.niveau]}
        </span>
      </div>
      <div className="flex items-end gap-3">
        <div data-testid="activity-gauge-pct" className="font-[Fraunces] text-3xl font-bold text-[#0A1426]">{c.ratio_pct} %</div>
        <div className="text-[12px] text-[#0A1426]/70 pb-1">{c.actes_distance} acte(s) à distance / {c.actes_total} acte(s) · {c.periode}</div>
      </div>
      <div className="relative h-3 bg-[#F5F3EE] rounded-full mt-2 overflow-hidden">
        <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${pct / c.seuil_pct * 100 > 100 ? 100 : pct / c.seuil_pct * 100}%`, background: color }} />
        <div className="absolute inset-y-0 right-0 w-0.5 bg-[#0A1426]" title="Seuil 20 %" />
      </div>
      {!compact && (
        <div className="flex justify-between text-[11px] text-[#0A1426]/60 mt-1">
          <span>0 %</span>
          <span>{c.marge_actes != null ? `${c.marge_actes} séance(s) à distance encore possibles` : "Historique insuffisant (< 5 actes) : avertissement seulement"}</span>
          <span>seuil {c.seuil_pct} %</span>
        </div>
      )}
    </div>
  );
}
